import type { ReactNode } from 'react'
import { Button } from '../Button/Button'
import { ImagePlaceholder } from '../ImagePlaceholder/ImagePlaceholder'
import { cx } from '../utils/cx'
import './DeductionCard.css'

export interface DeductionPhoto {
  id: string
  url?: string
  alt: string
}

export interface DeductionCardProps {
  /** Motivo, p. ej. "Motivo: lámpara del salón rota" */
  reason: ReactNode
  photos?: DeductionPhoto[]
  lines: { label: ReactNode; amount: ReactNode }[]
  totalLabel: ReactNode
  total: ReactNode
  claimLabel?: ReactNode
  onClaim?: () => void
  /** Nota bajo el botón, p. ej. plazo de reclamación */
  claimNote?: ReactNode
  className?: string
}

/** Tarjeta de deducción (bundle B3): motivo (h3) + rejilla de 2 fotos 4:3 + desglose + botón secundario "reclamar" + plazo. */
export function DeductionCard({ reason, photos = [], lines, totalLabel, total, claimLabel, onClaim, claimNote, className }: DeductionCardProps) {
  return (
    <div className={cx('hp-deduction', className)}>
      <div className="hp-deduction__reason">{reason}</div>
      {photos.length > 0 && (
        <div className="hp-deduction__photos">
          {photos.map((p) =>
            p.url ? (
              <img key={p.id} src={p.url} alt={p.alt} className="hp-deduction__photo" />
            ) : (
              <ImagePlaceholder key={p.id} label={p.alt} ratio="4 / 3" className="hp-deduction__photo" />
            ),
          )}
        </div>
      )}
      <dl className="hp-deduction__lines">
        {lines.map((l, i) => (
          <div key={i} className="hp-deduction__line">
            <dt>{l.label}</dt>
            <dd className="tnum">{l.amount}</dd>
          </div>
        ))}
        <div className="hp-deduction__line hp-deduction__line--total">
          <dt>{totalLabel}</dt>
          <dd className="tnum">{total}</dd>
        </div>
      </dl>
      {onClaim && (
        <Button variant="secondary" onClick={onClaim}>
          {claimLabel}
        </Button>
      )}
      {claimNote && <p className="hp-deduction__note">{claimNote}</p>}
    </div>
  )
}
